import { PencilIcon } from '@heroicons/react/24/outline';
import React from 'react';

const TextArea = ({ heading, rows, cols }) => {
  return (
    <div className="min-w-screen">
      <div className="block p-5 pl-10 bg-white border border-[#DDDDDD] rounded-2xl">
        <div className="flex justify-between">
          <h5 className="text-2xl tracking-tight text-gray-900 text-[25px]">
            {heading}
          </h5>
          <PencilIcon className="block h-6 w-6" aria-hidden="true" />
        </div>
        <div className="mt-6">
          <textarea
            id="textArea"
            name="textArea"
            placeholder="What is the project About? Where is it Used?"
            rows={rows}
            cols={cols}
            className="bg-[#E5E5E5] block rounded-md border-0 py-3 px-5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-black sm:text-sm sm:leading-6 placeholder:italic placeholder:font-semibold placeholder:text-[16px]"
            defaultValue={''}
          />
        </div>
      </div>
    </div>
  );
};

export default TextArea;
